<template>
    <div>
        <HeaderBg :img="img" :title="$t('investigator.title')" />
        <Alert 
            v-if="alertToggle == true"
            :acceptedDelete="acceptedDeleteInvestigator" 
            :messege="$t('investigator.confirmDelete')"
        />
        <header class="admin_content_header">
            <div class="filter">
                <!-- <select>
                    <option value="" selected disabled>المدينة</option>
                </select> -->
            </div>
            <div class="search">
                <!-- <input type="text" placeholder="البحث برقم الفرع"> -->
            </div>
            <!-- <router-link to="/admin/investigator/add-investigator"> + إضافة شرح جديد </router-link> -->
            
        </header>
        <RequestSpinner v-if="loadingRequest == true" />
        <div class="main_table" v-if="loadingRequest == false">
            <table width="100%">
                <thead>
                    <tr>
                        <th> {{$t('investigator.image')}} </th>
                        <th> {{$t('investigator.nameInArabic')}} </th>
                        <th> {{$t('investigator.nameInEnglish')}} </th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <div class="img_container">
                                <img :src="investigator[0].image" :alt="investigator[0].translation[0].name">
                            </div>
                        </td>
                        <td> {{investigator[0].translation[0].name}} </td>
                        <td> {{investigator[0].translation[1].name}} </td>
                        <td>
                            <div class="block actions">
                                <!-- <div class="delete" @click="() => deleteData(investigator[0].id)">
                                    <b-icon icon="trash" aria-hidden="true"></b-icon>
                                </div> -->
                                <div class="edit" @click="() => editIvestigator(investigator[0].id)">
                                    <img src="../../../assets/images/editLogo.svg" alt="">
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="pagination mt-5" v-if="investigator.length >= 1">
            <b-pagination-nav align="center" :link-gen="linkGen" :number-of-pages="pages" use-router v-model="currentPage"></b-pagination-nav>
        </div>
    </div>
</template>
<script>
import HeaderBg from '../../global/HeaderBg/HeaderBg';
import RequestSpinner from '../../global/loadingSpinners/RequestSpinner';
import store from "@/store/index.js";
import Request from '../../../services/Request';
import Alert from '../../global/Alert/Alert';

export default {
    name: 'Investigator',
    components: {HeaderBg, RequestSpinner, Alert},
    data(){
        return{
            loadingRequest: true,
            img: require('../../../assets/images/saleWhite.svg'),
            investigator: [],

            deleteID: '',
            alertToggle: false,

             // pagination
            apiParams: '',
            currentPage: 1,
            pages: 1,
        }
    },
    mounted(){
        this.getIvestigator();
    },
    methods:{
        getIvestigator(){
            Request.fetch('admin/investigator', this.apiParams , {
                limit: store.state.limit
            })
            .then((response) => {
                this.investigator = response.data.data
                this.loadingRequest = false;
                this.pages = Math.ceil(response.data.total / store.state.limit) 
            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/login')
                    localStorage.removeItem('token')
                }
            });
        },
        editIvestigator(id){
            this.$router.push(`/admin/investigator/add-investigator/${id}`)
        },
        deleteData(id){
            this.deleteID = id;
            this.alertToggle = true;
        },
        acceptedDeleteInvestigator(){
            Request.delete('admin/investigator',this.deleteID)
            .then( () => {
                this.getIvestigator();
            })
        },

        // pagination function
        linkGen(pageNum) {
            return pageNum === 1 ? '?' : `?page=${pageNum}`   
        },
    },
    watch: {
        // pagination
        currentPage: function(val) {
            if(val === 1){
                this.apiParams = '';
                this.getIvestigator();
            } else{
                this.apiParams = `?page=${val}`;
                this.getIvestigator();
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.saveBtn{
    margin-top: 0;
    display: block;
    &:hover{
        color: #FFF;
    }
}
.img_container{
    width: 70px;
    height: 70px;
    border-radius: 50%;
    overflow: hidden;
    img{
        width: 100%;
    }
}
.actions{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .delete,
    .edit{
        width: 40px;
        height: 34px;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #FF002B;
        cursor: pointer;
        svg{
            color: #FFF;
            font-size: 25px;
        }
    }
    .edit{
        background-color: #78A28F;
        margin-right: 10px;
    }
}
</style>